import { REHYDRATE } from 'redux-persist';
import { ActionTypes } from '../constants';

const defaults: State = {
  data: {
    sortFilter: false,
    viewType: 'list',
    viewErrorOrders: false,
    printGuestReceipt: true,
    printKitchenTicket: true,
    printFullOrder: true,
    fbDisableAutoPrinting: false,
    sortModel: { colId: '', sort: '' },
    pagination: false,
    groupedView: false,
  },
};

export interface ActionType {
  type: string;
  payload: any;
}

export default (state: State = defaults, action: ActionType) => {
  switch (action.type) {
    case ActionTypes.UPDATE_CHECK_SORT_FILTER: {
      return { ...state, data: { ...state.data, ...action.payload } };
    }
    case ActionTypes.UPDATE_VIEW_TYPE: {
      return { ...state, data: { ...state.data, ...action.payload } };
    }
    case REHYDRATE: {
      if (
        action.payload &&
        action.payload.checkSortReducer &&
        action.payload.checkSortReducer.data
      ) {
        return { ...state, ...action.payload.checkSortReducer };
      }
      return { ...defaults };
    }
    default:
      return state;
  }
};
